import { ChangeEvent } from 'react'

import { AppFlexContainer, AppFlexItem, AppFormSelect } from 'client/ui-building-blocks'

const OPTIONS = [
  {
    value: 'popular',
    text: 'Most popular',
  },
  {
    value: 'top',
    text: 'Top scores',
  },
]

type Props = {
  value: 'top' | 'popular'
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const ResultsTypeSelect = ({ value, onChange }: Props) => {
  return (
    <AppFlexContainer justifyContent="flex-end" verticalOnMobile>
      <AppFlexItem>
        <AppFormSelect options={OPTIONS} value={value} onChange={onChange} />
      </AppFlexItem>
    </AppFlexContainer>
  )
}

export default ResultsTypeSelect
